export default "__VITE_ASSET__CedyNAGK__"